import { normalizeLootConditionContext } from "./map-loot-condition-context.js";
import { resolveSearchExpression } from "./map-search-contract.js";
import { DEFAULT_VISIBLE_TRADE_NPC_CLASSES } from "./map-trade-npc-contract.js";

export const FISHYMAP_CONTRACT_VERSION = 1;
export const FISHYMAP_BRIDGE_V2_VERSION = 2;
export const FISHYMAP_POINT_ICON_SCALE_MIN = 1;
export const FISHYMAP_POINT_ICON_SCALE_MAX = 5;
export const FISHYMAP_POINT_ICON_SCALE_DEFAULT = 2;

export const FISHYMAP_EVENTS = Object.freeze({
  v2: "fishymap:v2",
});

export function createEmptyInputState() {
  return {
    version: FISHYMAP_CONTRACT_VERSION,
    theme: {
      name: undefined,
      colors: {},
    },
    filters: {
      searchExpression: resolveSearchExpression(undefined),
      layerIdsVisible: undefined,
      layerIdsOrdered: undefined,
      layerFilterBindingIdsDisabledByLayer: undefined,
      layerOpacities: undefined,
      layerHighlights: undefined,
      layerConfidenceShowcase: undefined,
      layerClipMasks: undefined,
      layerWaypointConnectionsVisible: undefined,
      layerWaypointLabelsVisible: undefined,
      layerPointIconsVisible: undefined,
      layerPointIconScales: undefined,
      layerPointClusteringEnabled: undefined,
      tradeNpcClassesVisible: DEFAULT_VISIBLE_TRADE_NPC_CLASSES.slice(),
      filterOnlyActiveConditionGroups: true,
      lootConditionSelection: {},
      lootConditionContext: normalizeLootConditionContext(undefined),
    },
    ui: {
      showPoints: true,
      showPointIcons: true,
      viewMode: null,
      threeDEnabled: true,
      pointIconScale: FISHYMAP_POINT_ICON_SCALE_DEFAULT,
      autoAdjustView: true,
      sampleFromFilteredElements: true,
      effectsEnabled: true,
      focusWavesEnabled: false,
      hoverFactsVisibleByLayer: {},
      bookmarkSelectedIds: [],
      bookmarks: [],
    },
    settings: {
      memoryBudgetMiB: 256,
    },
  };
}

export function createEmptySnapshot() {
  return {
    version: FISHYMAP_CONTRACT_VERSION,
    ready: false,
    theme: {
      name: undefined,
      colors: {},
    },
    filters: {
      searchExpression: resolveSearchExpression(undefined),
      layerIdsVisible: undefined,
      layerIdsOrdered: undefined,
      layerFilterBindingIdsDisabledByLayer: undefined,
      layerOpacities: undefined,
      layerHighlights: undefined,
      layerConfidenceShowcase: undefined,
      layerClipMasks: undefined,
      layerWaypointConnectionsVisible: undefined,
      layerWaypointLabelsVisible: undefined,
      layerPointIconsVisible: undefined,
      layerPointIconScales: undefined,
      layerPointClusteringEnabled: undefined,
      tradeNpcClassesVisible: DEFAULT_VISIBLE_TRADE_NPC_CLASSES.slice(),
      filterOnlyActiveConditionGroups: true,
      lootConditionSelection: {},
    },
    ui: {
      showPoints: true,
      showPointIcons: true,
      threeDEnabled: true,
      pointIconScale: FISHYMAP_POINT_ICON_SCALE_DEFAULT,
      autoAdjustView: true,
      sampleFromFilteredElements: true,
      effectsEnabled: true,
      focusWavesEnabled: false,
      hoverFactsVisibleByLayer: {},
      bookmarkSelectedIds: [],
      bookmarks: [],
    },
    view: {
      viewMode: "2d",
      camera: {},
    },
    selection: {},
    hover: {},
    catalog: {
      layers: [],
      patches: [],
      fish: [],
      items: [],
      semanticTerms: [],
    },
    statuses: {
      metaStatus: "",
      layersStatus: "",
      zonesStatus: "",
      pointsStatus: "",
      fishStatus: "",
      zoneStatsStatus: "",
    },
    effectiveFilters: {
      searchExpression: resolveSearchExpression(undefined),
      sharedFishState: {
        caughtIds: [],
        favouriteIds: [],
        showDried: false,
      },
      zoneMembershipByLayer: {},
      semanticFieldFiltersByLayer: {},
    },
    hotspotVisibility: {
      totalCount: 0,
      visibleCount: 0,
    },
    settings: {
      memoryBudgetMiB: 256,
    },
  };
}
